import {BasicSelect,MultiSelect} from 'vue-search-select';
import CreateServiceArea from './../createServiceAreaTemplate';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';

export default {
  name: 'serviceareatemplate',
  components: {
    Pagination,
    BasicSelect,
    CreateServiceArea,
    Loader,
    CustomExpandableTable
  },
  data: function() {
    return {
      serviceAreaName: '',
      action:"add",
      tableArr: [],
      zoneListArr: [],
      UpdateServiceArea: '',
      type: 'SERVICE_AREA_TEMPLATE',
      selectedServiceAreaObj: '',
      isLoading:false,
      Loader:false,
      showCreateServiceArea: false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: [ 'Template Name', 'Template Description', '# of Assigned Territory','Created By','Created Date','Status','Action'],
      innerTableColumn: ['Assigned Territory'],
      tableItems: [],
      status:"",
      statusSearch:"",
      serviceAreaNameSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
    }
  },
  computed: {

  },
  mounted() {
    this.getZoneList();
    this.getServiceAreaListing();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    clearForm() {
      this.currentPage =  1,
      this.serviceAreaName = '';
      this.serviceAreaNameSearch = '';
      this.status = "";
      this.statusSearch = "";
      this.statusitem = {};
      this.clientcutoffmasterid = "";
      this.getServiceAreaListing();
      document.getElementById("serviceAreaName").value= '';
      this.$validator.reset();
    },
    showServiceArea() {
      this.selectedServiceAreaObj = [];
      this.showCreateServiceArea = true;
    },
    callParent() {
        this.showCreateServiceArea = false;
        this.selectedServiceAreaObj = null;
        this.currentPage = 1;
        this.offset = 0;
        this.getServiceAreaListing();
      },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getServiceAreaListing()
    },
    searchServiceArea(){
      this.currentPage = 1;
      this.offset = 0;
      this.serviceAreaNameSearch = this.serviceAreaName;
      this.statusSearch = this.status;
      this.getServiceAreaListing();
    },
    async activeAction(data){
      try {
        this.isLoading = true;
        var item = this.tableArr.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("Service Area Activated Successfully!!", this.serviceAreaName, "success");
        }else{
          this.$alert("Service Area Inactivated Successfully!!", this.serviceAreaName, "success");
         }
          this.getServiceAreaListing();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
    getCustomTableEvent(event) {
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      if (event.actionType == "edit") {
        this.UpdateServiceArea = this.tableArr.filter(function (Items) {
          return Items.id == event.id;
        });
        this.selectedServiceAreaObj = this.UpdateServiceArea;
        this.showCreateServiceArea = true;
      }
    },
    async getZoneList(){
      try {
        this.Loader = true;
        let result = await MasterService.getZoneList();
        if (result.data.code == 200) {
          this.zoneListArr = result.data.data;
          this.Loader = false;
        }
      } catch(err){
        console.log(err);
      }
    },
    async getServiceAreaListing(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset":  this.offset,
          "limit": this.pageLimit
        }
        if(this.serviceAreaNameSearch!=""){
          inputPayload.serviceareaname= this.serviceAreaNameSearch;
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
        }
        let allResolved = await Promise.all([MasterService.getServiceAreaListing(inputPayload)])
        let result = allResolved[0]
        this.tableArr = result.data.data.rows;
        this.isLoading = false;
        this.tableItems = result.data.data.rows.map((el)=>{
          return {
            'id':el.id,
            'Template Name':el.serviceareaname,
            'Template Description': el.serviceareadescription,
            '# of Assigned Territory': el.serviceareadetails.length,
            'Created By':el.createdby,
            'Created Date':Util.displayDateTimeFormat(el.createddate),
            'Status': el.status,
            'Action': 'Need To Check1',
            'innerTableInfo':{
              'Assigned Territory':el.serviceareadetails.map((zoneObj)=>{
                let obj = this.zoneListArr.find(obj => obj.id == zoneObj.assignedzone);
                if(obj){
                  return obj.cargozonename
                }
              }).join(", ")
            }

          }
        })
        this.totalCount = result.data.data.count;
        this.resultCount = result.data.data.count;
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false
        //console.log(result);
      } catch(err){
        console.log(err);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ServiceAreaTemplate/serviceAreaListing/serviceAreaListing.component.js